import React from "react";

import { css } from "@emotion/css";
import { CellContext } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";

import { PractitionerBilling } from "@/models/PractitionerBillingModel.ts";
import { Typography } from "@/uiKit/atoms/Typography.tsx";
import { toDateTime } from "@/utils/dateUtils.ts";

export type PeriodColumnProps = CellContext<PractitionerBilling, string>;

export const PeriodColumn: React.FC<PeriodColumnProps> = ({ renderValue }) => {
  const period = renderValue() ?? "";

  return <Typography variant="body">{toDateTime(period).toFormat("MMMM yyyy")}</Typography>;
};

export const PeriodColumnHeader: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Typography variant="bodyLarge" className={css({ fontWeight: "bold" })}>
      {t("pages.practitionerBilling.period")}
    </Typography>
  );
};
